import { ControlledTextInput } from '@components/ControlledTextInput';
import { Collapsible, Typography } from '@gurupay/gp-ui-library';
import {
	AddressGroupInput,
	BeneficiaryTypeInput,
	PaymentDetailsSwitcher,
} from '@pages/templates/components';
import { useFormContext } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { CreatePaymentTemplate } from 'types/templates';

export const EuroPayment = () => {
	const { t } = useTranslation();
	const {
		control,
		formState: { errors },
	} = useFormContext<CreatePaymentTemplate>();

	return (
		<div className="space-y-space-16">
			<Typography level="h2">{t('payments.newPayment.data.title')}</Typography>
			<Typography level="h4">
				{t('payments.newPayment.data.transferType.label')}
			</Typography>
			<Controller
				control={control}
				name="payment_details"
				render={({ field }) => (
					<PaymentDetailsSwitcher<CreatePaymentTemplate>
						error={errors?.payment_details}
						{...field}
					/>
				)}
				rules={{
					maxLength: {
						message: t('payments.common.maxLength', { maxLength: 140 }),
						value: 140,
					},
				}}
			/>
			<Collapsible title={t('payments.newPayment.additionalData.button')}>
				<div className="space-y-space-16 my-space-16">
					<Typography level="h4">
						{t('payments.newPayment.additionalData.beneficiary')}
					</Typography>
					<AddressGroupInput<CreatePaymentTemplate>
						prefix="beneficiary.address"
						translatePrefix={'payments.newPayment.additionalData.address'}
					/>
					<BeneficiaryTypeInput<CreatePaymentTemplate>
						prefix="beneficiary.id"
						translatePrefix="payments.newPayment.additionalData.beneficiaryInfo"
					/>
					<Typography level={'h4'}>
						{t('payments.newPayment.additionalData.ultimateBeneficiary.title')}
					</Typography>
					<ControlledTextInput
						label={t('payments.newPayment.additionalData.ultimateBeneficiary.account')}
						name="ultimate_beneficiary.account"
					/>
					<ControlledTextInput
						label={t('payments.newPayment.additionalData.beneficiaryName')}
						name="ultimate_beneficiary.name"
						rules={{
							maxLength: {
								message: t('payments.common.maxLength', { maxLength: 70 }),
								value: 70,
							},
						}}
					/>

					<AddressGroupInput<CreatePaymentTemplate>
						prefix="ultimate_beneficiary.address"
						translatePrefix="payments.newPayment.additionalData.ultimateBeneficiary.address"
					/>

					<BeneficiaryTypeInput<CreatePaymentTemplate>
						prefix="ultimate_beneficiary.id"
						translatePrefix="payments.newPayment.additionalData.ultimateBeneficiary"
					/>
					<BeneficiaryTypeInput<CreatePaymentTemplate>
						prefix="payer"
						translatePrefix="payments.newPayment.additionalData.payer"
					/>
					<BeneficiaryTypeInput<CreatePaymentTemplate>
						prefix="primary_payer.id"
						translatePrefix="payments.newPayment.additionalData.ultimatePayer"
					/>
				</div>
			</Collapsible>
		</div>
	);
};
